// @flow

import 'isomorphic-fetch';

export default async (body: Object): Object => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV && NODE_ENV === 'development') {
    return Promise.resolve();
  }

  const response = await fetch('/log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...body,
    }),
  });

  if (response.status >= 400) {
    throw new Error(`Wrong status code: ${response.status}`);
  }

  return response.json();
};
